import React from 'react';
import { useTranslation } from 'react-i18next';
import { MoreOptionsIcon } from 'src/SharedComponents/Icons/Icons';
import './MoreOptions.css';

interface IChildren {
    children: React.ReactNode;
    disabled?: boolean;
}
const MoreOptionsMenu: React.FC<IChildren> = ({children, disabled}) => {
    const { t } = useTranslation();

    return (
        <div className={`moreButton ${disabled ? 'disabled' : ''}`}  >
            {/* data-bs-display="static" turns Popper off for this dropdown so the
                panel can be placed by CSS exactly where Figma puts it — flush
                under the trigger and aligned to its right edge. With Popper on,
                its inline transform wins over any positioning we write. */}
            <button
                type="button"
                className="menu-icon"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                data-bs-display="static"
                aria-expanded="false"
                aria-label={t('MoreOptions')}
                disabled={disabled}
            >
                <MoreOptionsIcon />
            </button>
            {children}
        </div>
    );
};

export default MoreOptionsMenu;
